/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, Suspense } from "react";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter,
  HashRouter,
  useHistory,
} from "react-router-dom";

import ScrollToTop from "./ScrollToTop";

import { lazyWithRetry } from "./ComponentLoader";
import { RouteWithSidebar } from "@vlinder-web/route-with-sidebar-widget-react";
import { PrivateRoute } from "@vlinder-web/private-route-widget-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";
import { VApplication } from "../application";
import { AppNavigatorService } from "../services";
import { useSMAppNavigator } from "./machines/pageContent";

//NOTE: Don't do lazy binding for landing page from v2 widget
import LandingPage from "../pages/Landing";
import ProductLandingPage from "../pages/ProductLanding";
import toast from "react-hot-toast";
import { DEFAULT_APP_CONFIG } from "../config/default.config";

//Pages
// const RegisterPage = lazyWithRetry(() => import("../pages/Register"));
// const SignInPage = lazyWithRetry(() => import("../pages/SignIn"));
// const SignUpPage = lazyWithRetry(() => import("../pages/SignUp"));
// const ForgotPasswordPage = lazyWithRetry(
//   () => import("../pages/ForgotPassword")
// );
// const ResetPasswordPage = lazyWithRetry(() => import("../pages/ResetPassword"));
// const LockAccountPage = lazyWithRetry(() => import("../pages/Lock"));
// const AccountSelectionPage = lazyWithRetry(
//   () => import("../pages/AccountSelection")
// );

//Sidebar Pages
// const ProfilePage = lazyWithRetry(() => import("../pages/Profile"));
// const DashboardOverviewPage = lazyWithRetry(
//   () => import("../pages/DashboardOverview")
// );
// const TrinetraPreviewPage = lazyWithRetry(
//   () => import("../pages/TrinetraPreview")
// );
// const TrinetraScannerPage = lazyWithRetry(
//   () => import("../pages/TrinetraScanner")
// );
const PlaceholderPage = lazyWithRetry(() => import("../pages/Placeholder"));
const ProductPage = lazyWithRetry(() => import("../pages/ProductPage"));
const ProductDetailPage = lazyWithRetry(
  () => import("../pages/ProductDetailPage")
);
const BadgeDetailPage = lazyWithRetry(() => import("../pages/BadgeDetailPage"));
//Privacy and Terms Pages

const TermsPage = lazyWithRetry(() => import("../pages/Terms"));
const PrivacyPage = lazyWithRetry(() => import("../pages/Privacy"));

//ErrorPages
const NotFoundPage = lazyWithRetry(() => import("../pages/Notfound"));
const ServerErrorPage = lazyWithRetry(() => import("../pages/ServerError"));

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const RouterConfig = () => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});
  const appNavSrv = getAppNavService();
  const history = useHistory();

  const _handleDropDownItemClick = (item: any) => {
    const storageSrv = StorageModule?.getInstance();

    console.log("on DD Item click =>", item);
    if (item.id === "logout") {
      storageSrv.reset("session");
      storageSrv.reset("local");
      window.open("/", "_self");
    } else {
      toast.success("Coming soon!");
    }
  };

  if (appNavigatorState?.matches("RENDER_PAGE")) {
    const {
      brandLogo,
      brandLogoLink,
      brandTitle,
      sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSection,
    } = { ...(appNavigatorState?.event?.data?.value || {}) };
    return (
      <Switch>
        <Route exact path="/" component={ProductLandingPage} />
        {/* <Route exact path={routes?.Register?.path} component={RegisterPage} />
        <Route exact path={routes?.SignIn?.path} component={SignInPage} />
        <Route exact path={routes?.SignUp?.path} component={SignUpPage} /> */}
        <Route exact path={routes?.Privacy?.path} component={PrivacyPage} />
        <Route exact path={routes?.Terms?.path} component={TermsPage} />
        <Route exact path={routes?.Product?.path} component={ProductPage} />
        {/* <Route
          path={routes?.TrinetraScanner?.path}
          component={TrinetraScannerPage}
        />
        <Route
          path={routes?.TrinetraPreview?.path}
          component={TrinetraPreviewPage}
        /> */}
        <Route
          exact
          path={routes?.ProductDetail?.path}
          component={ProductDetailPage}
        />
        <Route
          exact
          path={routes?.BadgeDetail?.path}
          component={BadgeDetailPage}
        />
        <Route
          exact
          path={routes?.Placeholder?.path}
          component={PlaceholderPage}
        />
        {/* <Route
          exact
          path={routes?.AccountSelection?.path}
          component={AccountSelectionPage}
        />

        <Route
          exact
          path={routes?.ResetPassword?.path}
          component={ResetPasswordPage}
        />
        <Route
          exact
          path={routes?.ForgotPassword?.path}
          component={ForgotPasswordPage}
        /> */}
        {/* <Route exact path={routes?.Lock?.path} component={LockAccountPage} /> */}
        <Route
          exact
          path={routes?.ServerError?.path}
          component={ServerErrorPage}
        />
        <Route exact path={routes?.NotFound?.path} component={NotFoundPage} />
{/* 
        <RouteWithSidebar
          exact
          path={routes?.Profile?.path}
          component={ProfilePage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.Profile?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.DashboardOverview?.path}
          component={DashboardOverviewPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.DashboardOverview?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        /> */}

        {/*<RouteWithSidebar*/}
        {/*  exact*/}
        {/*  path={routes?.Placeholder?.path}*/}
        {/*  component={PlaceholderPage}*/}
        {/*  brandLogo={brandLogo}*/}
        {/*  brandLogoLink={brandLogoLink}*/}
        {/*  brandTitle={brandTitle}*/}
        {/*  items={sidebarItems}*/}
        {/*  notFoundLink={routes?.NotFound?.path}*/}
        {/*  abilityCheck={appNavSrv?.abilityCheck.bind(*/}
        {/*    null,*/}
        {/*    routes?.Placeholder?.id,*/}
        {/*    whoami,*/}
        {/*    "read"*/}
        {/*  )}*/}
        {/*  userName={userName}*/}
        {/*  userImage={userImage}*/}
        {/*  dropDownItems={dropdownItems}*/}
        {/*  onDropDownItemClick={_handleDropDownItemClick}*/}
        {/*  orgName={orgName}*/}
        {/*  orgUrl={orgUrl}*/}
        {/*  copyrightStartYear={copyrightStartYear}*/}
        {/*  footerSections={footerSection}*/}
        {/*  // sidebarStyle={{ backgroundColor: "#113DA0" }}*/}
        {/*/>*/}
        <Redirect to={routes?.NotFound?.path} />
      </Switch>
    );
  }
  if (appNavigatorState?.matches("GET_PAGE_CONTENT")) {
    return <StateOSD {...(DEFAULT_APP_CONFIG?.defaultLoading || {})} />;
  }
  return null;
};

export const AppNavigator = (): JSX.Element => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense
        fallback={<StateOSD {...(DEFAULT_APP_CONFIG?.defaultLoading || {})} />}
      >
        <RouterConfig />
      </Suspense>
    </BrowserRouter>
  );
};
